import './style/normalize.css'
import './style/Colours.css'
import './style/Page_Layout.css'
import './style/Text.css'
import './style/App.css'
import './style/User_Advice.css'
import './style/Checkbox.css'
import '../Components/Toggle.css'
import {
	Client_State_Name,
} from '@quiz-buzz/client-common'
import {Player_Connection_Closed} from '../Player_Connection_Closed/Player_Connection_Closed'
import '../Help_Tips/Help_Tips.css'
import { Player_Registration } from '../Player_Registration/Player_Registration'
import { Player_Game_Setup } from '../Player_Game_Setup/Player_Game_Setup'
import { Player_In_Game } from '../Player_In_Game/Player_In_Game'
import { Player_Finished } from '../Player_Finished/Player_Finished'
import { Player_Trial_Ended } from '../Player_Trial_Ended/Player_Trial_Ended'
import { useSelector } from '@xstate/react'
import { player_machine_actor } from './main'


export function Player_Mode_Content() {

	const player_state_name = useSelector(player_machine_actor, (state) => state.value)

	return (
        <>
			{player_state_name === Client_State_Name.registering_player && (
				<Player_Registration />
			)}
			{player_state_name === Client_State_Name.player_game_setup && (
				<Player_Game_Setup />
			)}
			{player_state_name === Client_State_Name.player_in_game && (
				<Player_In_Game />
			)}
			{player_state_name === Client_State_Name.player_finished && (
				<Player_Finished />
			)}
			{player_state_name === Client_State_Name.player_trial_ended && (
				<Player_Trial_Ended />
			)}
			{player_state_name === Client_State_Name.connection_closed && (
				<Player_Connection_Closed />
			)}
        </>
	)
}



